module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2319"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2319"
    },
    "bundlingPackage": "marketplace-storefront-public-ui",
    "bundlingPackageVersion": "static-1.13137",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};